import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    :root {
        --color-background: ${(props) => props.theme.bgColor};
        --color-bg-shades: ${(props) => props.theme.bgShade};
        --color-bg-shades2: ${(props) => props.theme.bgShade2};
        --color-bg-shades3: ${(props) => props.theme.bgShade3};
        --color-primary: ${(props) => props.theme.color01};
        --color-primary-dark: ${(props) => props.theme.color02};
        --color-text: ${(props) => props.theme.fgColor};
        --color-text2: ${(props) => props.theme.fgColor2};
        --color-text3: ${(props) => props.theme.fgColor3};
        --shadow-main-outer: ${(props) => props.theme.outerShadow};
        --shadow-empty: ${(props) => props.theme.EmptyShadow};
        --shadow-main-inner: ${(props) => props.theme.innerShadow};
        --color-success: green;
        --color-danger: red;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        outline: none;
    }

    *::before, 
    *::after {
        box-sizing: border-box;
    }

    *:not(i) {
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
    }

    html {
        font-size: 62.5%;

        @media screen and (max-width:1000px) {
            font-size: 50%;
        }
    }

    body {
        line-height: 1.5;
        overflow-x: hidden;
        background-color: var(--color-background);
    }

    body.stop-scroll {
        overflow-y: hidden;
    }

    a {
        text-decoration: none;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    img {
        vertical-align: middle;
        max-width: 100%;
    }

    .container {
        max-width: 1140px;
        margin: auto;
    }


    .row {
        display: flex;
        flex-wrap: wrap;
    }

    .justify-space-between {
        justify-content: space-between;
    }

    .full-width {
        width: 100%;
    }

    .align-items-center {
        align-items: center;
    }

    .outside-shadow {
        box-shadow: var(--shadow-main-outer);
    }

    .inner-shadow {
        box-shadow: var(--shadow-main-inner);
    }

    .hover-in-shadow {
        position: relative;
        z-index: 1;
    }

    .hover-in-shadow:hover {
        box-shadow: var(--shadow-empty);
    }

    .hover-in-shadow::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all .3s ease;
        z-index: -1;
    }

    .hover-in-shadow:hover::after {
        box-shadow: var(--shadow-main-inner);
    }

    .btn-link {
        padding: 1rem 2.5rem;
        font-size: 2rem;
        font-weight: 500;
        color: var(--color-primary-dark);
        background-color: transparent;
        line-height: 1.6;
        border-radius: 30px;
        cursor: pointer;
        transition: all .3s ease;
        display: inline-block;
        border: none;

        &::after {
            border-radius: 30px;
        }
    }

    .section__title {
        padding: 0 1.5rem;
        flex: 0 0 100%;
        max-width: 100%;
        text-align: center;
    }

    .section__title h2 {
        display: inline-block;
        font-size: 3rem;
        font-weight: 700;
        color: var(--color-text);
        text-transform: uppercase;
        margin-bottom: 6rem;
    }

    .section__title h2::before {
        display: block;
        content: attr(data-heading);
        font-size: 1.6rem;
        font-weight: 600;
        color: var(--color-primary-dark);
    }

    @keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

`;